<template>
  <sub-page title="设置">
    <div class="settings-page">
      <!-- 设置项列表 -->
      <div class="settings-list">
        <div
          v-for="item in items"
          :key="item.title"
          class="settings-item"
          @click="handleClick(item)"
        >
          <!-- 缺少图片素材的图标用内联SVG绘制 -->
          <svg v-if="item.svg === 'auth'" viewBox="0 0 24 24" class="item-icon">
            <circle cx="12" cy="12" r="10" fill="none" stroke="#E08A50" stroke-width="2"/>
            <path d="M7.5 12.2 L10.6 15.3 L16.5 9" fill="none" stroke="#E08A50" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <svg v-else-if="item.svg === 'trash'" viewBox="0 0 24 24" class="item-icon" fill="none" stroke="#33B3A6" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
            <path d="M4 7 h16"/>
            <path d="M9 7 V5.5 C9 4.7 9.7 4 10.5 4 h3 C14.3 4 15 4.7 15 5.5 V7"/>
            <path d="M6.5 7 L7.3 19 C7.4 19.8 8 20.5 8.9 20.5 h6.2 C16 20.5 16.6 19.8 16.7 19 L17.5 7"/>
            <path d="M10 11 v5.5 M14 11 v5.5"/>
          </svg>
          <img v-else :src="icons[item.icon]" class="item-icon" :alt="item.title" />
          <span class="item-title">{{ item.title }}</span>
          <span v-if="item.extra" class="item-extra">{{ item.key === 'cache' ? cacheSize : item.extra }}</span>
          <svg viewBox="0 0 24 24" class="item-arrow">
            <path d="M9 5 L16 12 L9 19" fill="none" stroke="#c8c9cc" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>

      <!-- 退出登录 -->
      <div class="logout-bar" @click="handleLogout">退出登录</div>

      <!-- 底部灰色留白（自动填满剩余高度） -->
      <div class="bottom-space"></div>

      <!-- 退出登录确认弹窗 -->
      <div class="logout-dialog-mask" v-if="showLogoutDialog">
        <div class="logout-dialog">
          <div class="dialog-title">提示</div>
          <div class="dialog-message">您确定要退出吗？</div>
          <div class="dialog-btns">
            <button class="dialog-btn cancel" type="button" @click="showLogoutDialog = false">取消</button>
            <button class="dialog-btn confirm" type="button" @click="confirmLogout">确定</button>
          </div>
        </div>
      </div>
    </div>
  </sub-page>
</template>

<script>
import SubPage from './SubPage.vue'

const iconContext = require.context('@/assets/icons', false, /\.png$/)
const icons = {}
iconContext.keys().forEach(key => {
  const name = key.replace(/^\.\//, '').replace(/\.png$/, '')
  icons[name] = iconContext(key)
})

export default {
  name: 'Settings',
  components: { SubPage },
  data() {
    return {
      icons,
      showLogoutDialog: false,
      cacheSize: '2.42MB',
      items: [
        { title: '我的认证', svg: 'auth', key: 'auth' },
        { title: '修改密码', icon: 'set-lock', key: 'password' },
        { title: '修改手机号', icon: 'set-phone', key: 'phone' },
        { title: '清理缓存', svg: 'trash', key: 'cache', extra: true },
        { title: '用户协议', icon: 'set-doc', key: 'agreement-user' },
        { title: '隐私政策', icon: 'set-shield', key: 'privacy' },
        { title: '隐私政策摘要', icon: 'set-shield', key: 'privacy-summary' },
        { title: '第三方信息共享清单', icon: 'set-doc', key: 'third-party-list' },
        { title: '已收集个人信息清单', icon: 'set-doc', key: 'collected-info-list' },
        { title: '关于', icon: 'set-about', key: 'about' }
      ]
    }
  },
  methods: {
    // 标题收缩适配：恢复默认字号后逐档缩小，保证单行不折行
    fitTitles() {
      const els = this.$el.querySelectorAll('.item-title')
      els.forEach(el => { el.style.fontSize = '' })
      void this.$el.offsetWidth
      els.forEach(el => {
        let fs = parseFloat(getComputedStyle(el).fontSize)
        let guard = 0
        while (el.scrollWidth > el.clientWidth && fs > 10 && guard < 40) {
          fs -= 0.5
          el.style.fontSize = fs + 'px'
          guard++
        }
      })
    },
    handleClick(item) {
      // 清理缓存：原地提示并归零，不跳转
      if (item.key === 'cache') {
        this.cacheSize = '0.00MB'
        this.$alert('缓存已清理')
        return
      }
      const routeMap = {
        auth: '/my-auth',
        password: '/change-password',
        phone: '/change-phone',
        'agreement-user': '/agreement-user',
        privacy: '/privacy',
        'privacy-summary': '/privacy-summary',
        'third-party-list': '/third-party-list',
        'collected-info-list': '/collected-info-list',
        about: '/about'
      }
      const path = routeMap[item.key]
      if (path) {
        this.$router.push(path)
      }
    },
    handleLogout() {
      this.showLogoutDialog = true
    },
    // 确定：清除登录态并回到「我的」页（未登录头部样式）
    confirmLogout() {
      this.showLogoutDialog = false
      localStorage.removeItem('jszhrs_logged_in')
      this.$router.push('/mine')
    }
  },
  mounted() {
    // 系统字体放大/缩小后，标题自适应收缩保持单行
    this.$nextTick(this.fitTitles)
    setTimeout(this.fitTitles, 300)
    window.addEventListener('resize', this.fitTitles)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.fitTitles)
  }
}
</script>

<style scoped>
.settings-page {
  background: #F8F8F8;
  min-height: 100%;
  /* 纵向弹性：底部灰色留白自动填满剩余高度 */
  display: flex;
  flex-direction: column;
}
.settings-list {
  background: #fff;
}
.settings-item {
  display: flex;
  align-items: center;
  height: calc(148 * var(--w));
  padding-left: calc(44 * var(--w));
  background: #fff;
  border-bottom: 1px solid #ebebeb;
  cursor: pointer;
}
.settings-item:last-child {
  border-bottom: none;
}
.item-icon {
  width: calc(56 * var(--w));
  height: calc(56 * var(--w));
  object-fit: contain;
  flex-shrink: 0;
}
.item-title {
  flex: 1;
  /* flex子项允许收缩，长标题不挤压其他元素 */
  min-width: 0;
  margin-left: calc(50 * var(--w));
  font-size: calc(40 * var(--w));
  color: #323233;
  /* 系统字体放大时标题保持单行，由JS自动收缩字号 */
  white-space: nowrap;
  overflow: hidden;
}
.item-extra {
  font-size: calc(30 * var(--w));
  color: #c8c9cc;
  margin-right: calc(30 * var(--w));
  white-space: nowrap;
  flex-shrink: 0;
}
.item-arrow {
  width: calc(27 * var(--w));
  height: calc(27 * var(--w));
  margin-right: calc(36 * var(--w));
  flex-shrink: 0;
}
/* 退出登录：上下灰缝32w，白条高134w */
.logout-bar {
  margin-top: calc(32 * var(--w));
  height: calc(134 * var(--w));
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: calc(40 * var(--w));
  color: #4E88BC;
  cursor: pointer;
  white-space: nowrap;
}
/* 底部灰色留白 */
.bottom-space {
  flex: 1;
  min-height: calc(60 * var(--w));
}
/* 退出登录确认弹窗 */
.logout-dialog-mask {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}
.logout-dialog {
  width: 80%;
  background: #fff;
  border-radius: calc(32 * var(--w));
  overflow: hidden;
}
.dialog-title {
  padding: calc(52 * var(--w)) calc(48 * var(--w)) 0;
  text-align: center;
  font-size: calc(44 * var(--w));
  font-weight: bold;
  color: #1A1A1A;
}
.dialog-message {
  padding: calc(28 * var(--w)) calc(48 * var(--w)) calc(56 * var(--w));
  text-align: center;
  font-size: calc(40 * var(--w));
  color: #333;
  line-height: 1.5;
}
.dialog-btns {
  display: flex;
  border-top: 1px solid #f0f0f0;
}
.dialog-btn {
  flex: 1;
  height: calc(108 * var(--w));
  font-size: calc(40 * var(--w));
  border: none;
  background: #fff;
  cursor: pointer;
  font-family: inherit;
}
.dialog-btn.cancel {
  color: #666;
  border-right: 1px solid #f0f0f0;
}
.dialog-btn.confirm {
  color: #fff;
  background: #3B97E8;
}
.dialog-btn.confirm:active {
  background: #2F86D4;
}
</style>



// WEBPACK FOOTER //
// src/pages/Settings.vue